import { ApplicationRef, Component, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injector, OnInit, Type } from '@angular/core';

@Component({
  selector: 'app-in-content-block-shell',
  templateUrl: './in-content-block-shell.component.html',
  styleUrls: ['./in-content-block-shell.component.scss']
})
export class InContentBlockShellComponent {

  private attached: boolean = false;

  private disposeFn: () => void;

  constructor(
    private hostElement: Element,
    private appRef: ApplicationRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
  ) { }

  attach(component: Type<any>): ComponentRef<any> {
    if(this.attached) {
      throw new Error('component has already been attached')
    }

    this.attached = true;
    const childComponentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

    let componentRef = childComponentFactory.create(this.injector);

    this.appRef.attachView(componentRef.hostView);
    this.disposeFn = () => {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
    };

    // remove any existing child nodes of the target element
    while (this.hostElement.firstChild) {
      this.hostElement.removeChild(this.hostElement.firstChild);
    }

    this.hostElement.appendChild((componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0]);

    return componentRef;
  }

  dispose() {
    if (this.attached) {
      this.disposeFn();
    }
  }

}
